import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {OnboardingDependencies} from '../dependencies';
import {keys} from './keys';

export type GetOnboardingStatusQueryDependencies = Pick<OnboardingDependencies, 'controllers'>;

/**
 * Query factory for the onboarding completion flag. The protected layout
 * loader uses it to decide whether to redirect to `/onboarding`.
 */
export const getOnboardingStatusQuery = ({controllers}: GetOnboardingStatusQueryDependencies) =>
  queryOptions({
    queryKey: keys.onboardingStatus(),
    queryFn: () => controllers.onboardingController.getStatus().then(unwrap),
    // Storage reads are synchronous-ish; treat as fresh for a session.
    staleTime: Number.POSITIVE_INFINITY,
  });
